import {
  ApplicationConfig,
  LOCALE_ID,
  provideZoneChangeDetection,
  inject,
  provideAppInitializer,
  provideEnvironmentInitializer,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import {
  MAT_PAGINATOR_DEFAULT_OPTIONS,
  MatPaginatorIntl,
} from '@angular/material/paginator';
import { CustomPaginatiorIntl } from './core/utils/classes/custom-paginatior-intl';
import { MAT_CARD_CONFIG } from '@angular/material/card';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import { Observable } from 'rxjs';
import { AuthService } from './core/services/auth/auth.service';
import { PerfilUsuario } from './shared/models';
import { RouterHistoryServiceService } from './core/services/router-service/router-history-service.service';
import { ThemeService } from './core/services/theme-service/theme.service';
import { RecaptchaEnterpriseService } from '@core/services/recaptcha/recaptcha-enterprise.service';
import { provideFirebase } from '@core/providers/firebase.providers';
registerLocaleData(localeEsMx, 'es-MX');

export function inicializarAuthFactory(
  authService: AuthService,
): () => Observable<PerfilUsuario | null> {
  return () => authService.cargarPerfilUsuario();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
      },
    },
    {
      provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
      useValue: {
        showFirstLastButtons: true,
      },
    },
    {
      provide: MatPaginatorIntl,
      useClass: CustomPaginatiorIntl,
    },
    {
      provide: MAT_CARD_CONFIG,
      useValue: {
        appearance: 'raised',
      },
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 7000,
      },
    },
    {
      provide: LOCALE_ID,
      useValue: 'es-MX',
    },
    provideFirebase(),
    provideAppInitializer(() => {
      const initializerFn = inicializarAuthFactory(inject(AuthService));
      return initializerFn();
    }),
    provideEnvironmentInitializer(() => {
      const recaptchaService = inject(RecaptchaEnterpriseService);
      recaptchaService.initRouteListener();
      inject(ThemeService);
      inject(RouterHistoryServiceService);
    }),
  ],
};
